import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import { ButtonProps } from '@mui/material';

type IProps = ButtonProps; // your custom props

// eslint-disable-next-line react/function-component-definition
function ResponsiveButton({ children, ...buttonProps }: IProps): JSX.Element {
  const theme = useTheme();

  return (
    <Button
      data-testid="responsive-button"
      {...buttonProps}
      fullWidth={useMediaQuery(theme.breakpoints.down('sm'))}>
      {children}
    </Button>
  );
}

export default ResponsiveButton;
